import React from 'react';
import SimulationReportGenericLayoutSetting from './SimulationReportGenericLayoutSetting';
import TabSec from './TabSec';
import GetSimulationReportGeneralSetting from './GetSimulationReportGeneralSetting';

export default function GenericLayoutSettings({
  formikProps,
  device,
  setDevice,
  treatment,
  setTreatment,
  language,
  setLanguage,
  tab = 'SmbSimulationResultPage',
  setTab,
}) {
  const tabBody = () => {
    if (tab === 'SmbSimulationResultPage') {
      return (
        <SimulationReportGenericLayoutSetting
          formikProps={formikProps}
          device={device}
          setDevice={setDevice}
          treatment={treatment}
          setTreatment={setTreatment}
          language={language}
          setLanguage={setLanguage}
        />
      );
    }
    return <GetSimulationReportGeneralSetting formikProps={formikProps} />;
  };
  return (
    <div>
      <TabSec tab={tab} setTab={setTab} />
      {tabBody()}
    </div>
  );
}
